function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.824 1.943a2.43 2.43 0 100 4.86 2.43 2.43 0 000-4.86zM2.45 4.373a3.373 3.373 0 116.746 0 3.373 3.373 0 01-6.746 0zm9.901.98c.26 0 .472.21.472.47v1.705h1.704a.472.472 0 010 .944h-1.704v1.704a.472.472 0 01-.943 0V8.472h-1.705a.472.472 0 110-.943h1.705V5.824c0-.26.21-.472.471-.472zm-6.528 4.57a3.88 3.88 0 00-3.881 3.88v.254h7.762v-.254a3.88 3.88 0 00-3.881-3.88zM1 13.802a4.824 4.824 0 019.648 0v.725c0 .26-.211.472-.472.472H1.472A.472.472 0 011 14.528v-.725z",
  fill: "#2D2D2D"
});
function SvgAgregarpersonausuaria(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Agregar persona usuaria.svg";
export { SvgAgregarpersonausuaria as ReactComponent };